import { DatePipe } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import {
  Instruction,
  InstructionProgress,
} from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";
import { ColorService } from "src/app/services/color.service";
import { DeadlineService } from "src/app/services/deadline.service";

@Component({
  selector: "app-instruction-item",
  imports: [TranslatePipe, DatePipe],
  templateUrl: "./instruction-item.component.html",
  styles: ``,
})
export class InstructionItemComponent {
  instruction = input.required<Instruction>();
  instructionConfirmation = input.required<InstructionConfirmation>();
  progress = input.required<InstructionProgress>();
  showProgress = input.required<boolean>();

  progressPercentage = computed(() => {
    const progress = this.progress();

    if (progress && progress.totalChapters > 0) {
      return Math.ceil(
        (progress.confirmedChapters / progress.totalChapters) * 100,
      );
    }
    return 0;
  });

  open = output<{
    instruction: Instruction;
    confirmation: InstructionConfirmation;
    progress: InstructionProgress;
  }>();

  // TODO: unused!
  colorStyles = computed(() => {
    const color = this.colorService.colorFromId(this.instruction().name);
    return {
      "border-color": `hsl(${color.h}, ${color.s}%, ${color.l}%)`,
    };
  });

  deadlineStatus = computed(() => {
    return this.deadlineService.deadlineStatus(
      this.instructionConfirmation().deadline,
    );
  });

  constructor(
    private readonly colorService: ColorService,
    private readonly deadlineService: DeadlineService,
  ) {}

  clicked() {
    this.open.emit({
      instruction: this.instruction(),
      confirmation: this.instructionConfirmation(),
      progress: this.progress(),
    });
  }
}
